const translations = {
  "en": {
    "Loading": "Loading"
  },
  "zh-tw": {
    "Loading": "載入中"
  }
};

export default translations;
